var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLvLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 136.01 30.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ed1c24;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.69,5.56C6.51,3.17,5.49,1.64,5.49.09a.11.11,0,0,0-.21,0C5,1.47,4.57,3.32,5.66,4.77c1.11,1.65.34,2.37.07,2.52a1,1,0,0,1-1.06-.06C4.28,7,4.2,6.57,4.18,5.6,4,4.75.9,10.2,4.94,13.27a4.06,4.06,0,0,0,1,.54c.1,0,.28.06.13-.1-2.33-2.28.19-4.72.16-4.08A2.55,2.55,0,0,0,6.34,11a1,1,0,0,0,1,.59c.27-.06,1.1-.27.51-1.72A4.89,4.89,0,0,1,8,7.14c0-.12.13-.09.15,0A4.24,4.24,0,0,0,9.53,9.5a3.34,3.34,0,0,1,1.3,2,4.31,4.31,0,0,1-.07,2.37c0,.06,0,.12.16,0C13.89,11.11,13.25,8.23,9.69,5.56Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "10.09 16.25 8.33 19.32 6.58 16.25 0 16.25 1.01 17.99 4.35 17.99 4.35 18 5.4 18 8.33 23.08 11.27 18 13.46 18 10.52 23.09 10.53 23.09 11.63 24.98 16.66 16.25 10.09 16.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "8.33 26.88 4.21 19.75 2.02 19.75 8.33 30.71 10.53 26.9 9.42 24.98 8.33 26.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.15,16.24h1.67v5.64h5v1.39H22.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.74,16.24h6.78v1.42h-5.1V19h4.21v1.35H33.42v1.53h5.25v1.39H31.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.85,16.19h1.86l3.64,7.08H48.56l-.75-1.43H43.62l-.74,1.43H41.22Zm2.33,4.4-1.46-2.82-1.47,2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.27,16.24h4.07c2.14,0,3.9.92,3.9,3.48s-1.79,3.55-3.9,3.55H53.27Zm4.09,5.67a1.94,1.94,0,0,0,2.2-2.18,1.92,1.92,0,0,0-2.22-2.1H54.93v4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.13,16.24H65l2.8,5.42,2.8-5.42h1.71l-3.64,7.07H66.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.2,16.24H82v1.42H76.87V19h4.21v1.35H76.87v1.53h5.26v1.39H75.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.23,16.24h1.85l4.49,4.82V16.24h1.6v7H91.53l-4.7-5v5h-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.22,17.66H96.14V16.24H104v1.42h-3.07v5.61H99.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.86,20.51V16.24h1.66v4.24c0,1,.89,1.48,2.33,1.48s2.33-.45,2.33-1.48V16.24h1.63v4.27c0,1.85-1.42,2.87-4,2.87S106.86,22.36,106.86,20.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.16,16.24H123c1.77,0,2.83.61,2.83,2.23a1.88,1.88,0,0,1-1.47,2l1.56,2.78h-1.78l-1.44-2.55h-2.86v2.55h-1.66Zm4.77,3.16c.85,0,1.25-.26,1.25-.88s-.4-.9-1.25-.9h-3.11V19.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M129.08,16.24h6.78v1.42h-5.1V19H135v1.35h-4.21v1.53H136v1.39h-6.93Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLvLogo);
export default __webpack_public_path__ + "static/media/lv-logo.9ecd0f3ebdddda4178c9168a6de4cb5c.svg";
export { ForwardRef as ReactComponent };